const CaptureDataSourceID = [
	// the data source ID is not specified or initialized
	{name: 'NotSpecified', value: 0 },

	// the barcode symbology for Australia post
	{name: 'SymbologyAustraliaPost', value: 1 },

	// the barcode symbology Aztec
	{name: 'SymbologyAztec', value: 2 },

	// the barcode symbology Bookland EAN
	{name: 'SymbologyBooklandEan', value: 3 },

	// the barcode symbology for British post
	{name: 'SymbologyBritishPost', value: 4 },

	// the barcode symbology for Canada post
	{name: 'SymbologyCanadaPost', value: 5 },

	// the barcode symbology Chinese 2 of 5
	{name: 'SymbologyChinese2of5', value: 6 },

	// the barcode symbology Codabar
	{name: 'SymbologyCodabar', value: 7 },

	// the barcode symbology Codablock A
	{name: 'SymbologyCodablockA', value: 8 },

	// the barcode symbology Codablock F
	{name: 'SymbologyCodablockF', value: 9 },

	// the barcode symbology Code 11
	{name: 'SymbologyCode11', value: 10 },

	// the barcode symbology Code 39
	{name: 'SymbologyCode39', value: 11 },

	// the barcode symbology Code 39 Extended
	{name: 'SymbologyCode39Extended', value: 12 },

	// the barcode symbology Code 39 Trioptic
	{name: 'SymbologyCode39Trioptic', value: 13 },

	// the barcode symbology Code 93
	{name: 'SymbologyCode93', value: 14 },

	// the barcode symbology Code 128
	{name: 'SymbologyCode128', value: 15 },

	// the barcode symbology DataMatrix
	{name: 'SymbologyDataMatrix', value: 16 },

	// the barcode symbology for Dutch post
	{name: 'SymbologyDutchPost', value: 17 },

	// the barcode symbology EAN 8
	{name: 'SymbologyEan8', value: 18 },

	// the barcode symbology EAN 13
	{name: 'SymbologyEan13', value: 19 },

	// the barcode symbology EAN 128
	{name: 'SymbologyEan128', value: 20 },

	// the barcode symbology EAN 128 Irregular
	{name: 'SymbologyEan128Irregular', value: 21 },

	// the barcode symbology EAN UCC Composite AB
	{name: 'SymbologyEanUccCompositeAB', value: 22 },

	// the barcode symbology EAN UCC Composite C
	{name: 'SymbologyEanUccCompositeC', value: 23 },

	// the barcode symbology GS1 Databar
	{name: 'SymbologyGs1Databar', value: 24 },

	// the barcode symbology GS1 Databar Limited
	{name: 'SymbologyGs1DatabarLimited', value: 25 },

	// the barcode symbology GS1 Databar Expanded
	{name: 'SymbologyGs1DatabarExpanded', value: 26 },

	// the barcode symbology Interleaved 2 of 5
	{name: 'SymbologyInterleaved2of5', value: 27 },

	// the barcode symbology ISBT 128
	{name: 'SymbologyIsbt128', value: 28 },

	// the barcode symbology for Japan post
	{name: 'SymbologyJapanPost', value: 29 },

	// the barcode symbology Matrix 2 of 5
	{name: 'SymbologyMatrix2of5', value: 30 },

	// the barcode symbology Maxi Code
	{name: 'SymbologyMaxicode', value: 31 },

	// the barcode symbology MSI
	{name: 'SymbologyMsi', value: 32 },

	// the barcode symbology PDF 417
	{name: 'SymbologyPdf417', value: 33 },

	// the barcode symbology PDF 417 Micro
	{name: 'SymbologyPdf417Micro', value: 34 },

	// the barcode symbology Planet
	{name: 'SymbologyPlanet', value: 35 },

	// the barcode symbology Plessey
	{name: 'SymbologyPlessey', value: 36 },

	// the barcode symbology Postnet
	{name: 'SymbologyPostnet', value: 37 },

	// the barcode symbology QR Code
	{name: 'SymbologyQRCode', value: 38 },

	// the barcode symbology Standard 2 of 5
	{name: 'SymbologyStandard2of5', value: 39 },

	// the barcode symbology Telepen
	{name: 'SymbologyTelepen', value: 40 },

	// the barcode symbology TLC 39
	{name: 'SymbologyTlc39', value: 41 },

	// the barcode symbology UPC A
	{name: 'SymbologyUpcA', value: 42 },

	// the barcode symbology UPC E0
	{name: 'SymbologyUpcE0', value: 43 },

	// the barcode symbology UPC E1
	{name: 'SymbologyUpcE1', value: 44 },

	// the barcode symbology USPS Intelligent Mail
	{name: 'SymbologyUspsIntelligentMail', value: 45 },

	// the barcode symbology Direct Part Marking
	{name: 'SymbologyDirectPartMarking', value: 46 },

	// the barcode symbology Han Xin
	{name: 'SymbologyHanXin', value: 47 },

	// the barcode symbology DotCode
	{name: 'SymbologyDotCode', value: 48 },

	// the barcode symbology Digimarc
	{name: 'SymbologyDigimarc', value: 49 },

	// the last barcode symbology ID', not an actual barcode symbology
	{name: 'LastSymbologyID', value: 50 },

	// the RFID Tag Type ISO 14443 A
	{name: 'TagTypeISO14443TypeA', value: 256 },

	// the RFID Tag Type ISO 14443 B
	{name: 'TagTypeISO14443TypeB', value: 257 },

	// the RFID Tag Type Felica
	{name: 'TagTypeFelica', value: 258 },

	// the RFID Tag Type ISO 15693
	{name: 'TagTypeISO15693', value: 259 },

	// the RFID Tag Type NXPI Code 1
	{name: 'TagTypeNXPICODE1', value: 260 },

	// the RFID Tag Type Inside Secure Pico Tag
	{name: 'TagTypeInsideSecurePicoTag', value: 261 },

	// the RFID Tag Type Innovision Topaz Jewel
	{name: 'TagTypeInnovisionTopazJewel', value: 262 },

	// the RFID Tag Type Thin Film NFC Barcode
	{name: 'TagTypeThinfilmNFCBarcode', value: 263 },

	// the RFID Tag Type ST Micro Electronics SR
	{name: 'TagTypeSTMicroElectronicsSR', value: 264 },

	// the RFID Tag Type ASK CTS 256B or CTS 512B
	{name: 'TagTypeASKCTS256BOrCTS512B', value: 265 },

	// the RFID Tag Type NFC Forum
	{name: 'TagTypeNFCForum', value: 266 },

	// the RFID Tag Type Innovatron Radio Protocol
	{name: 'TagTypeInnovatronRadioProtocol', value: 267 },

	// the last RFID tag type', not an actual tag type
	{name: 'TagTypeLastTagType', value: 268 },

 ];


 export default CaptureDataSourceID;
